<div scrollbarWithEndingBlinds
  class="autocomplete-list"
  [updateOn]="changeDetectionSafeItemsUpdate$">

  @for (displayVariant of displayVariants; track displayVariant) {
    <li class="autocomplete-list-item"
      [class.-selected]="displayVariant.variant === selectedVariant"
      (mouseover)="selectedVariant = displayVariant.variant"
      (click)="selectVariant(displayVariant.variant)"
      #item>
      {{displayVariant.displayValue}}
    </li>
  }

  @if (!displayVariants?.length) {
    <li class="autocomplete-list-item">{{'components.autocomplete.nothing_found' | l10n}}</li>
  }
</div>
